import { FC, SetStateAction, useEffect } from "react";
import { Icon } from "../icons";
import { styled } from "styled-components";

type SnackbarProps = {
  isError: boolean;
  text: string | null;
  onTimeOut?: React.Dispatch<SetStateAction<string | null>>;
};

export const Snackbar: FC<SnackbarProps> = ({
  text,
  isError = false,
  onTimeOut,
}) => {
  useEffect(() => {
    if (text && onTimeOut) {
      const timer = setTimeout(() => {
        onTimeOut(null);
      }, 6000);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [text, onTimeOut]);

  if (!text) {
    return null;
  }

  return (
    <Wrapper>
      <Content>
        {isError ? (
          <>
            <Icon.Warning />
            <Text data-testid="message-error-snackbar">{text}</Text>
          </>
        ) : (
          <>
            <Icon.CheckCircle />
            <Text data-testid="message-success-snackbar">{text}</Text>
          </>
        )}
      </Content>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  min-width: 30px;
  padding: 8px 20px;
  font-family: ${({ theme }) => theme.FONT.FAMILY.BODY};
  font-size: 16px;
  background: ${({ theme }) => theme.COLORS.GRAY_DARK};
  color: ${({ theme }) => theme.COLORS.WHITE};
`;

const Text = styled.p`
  margin: 0;
  padding: 0 0 0 10px;
`;
